import React, { PureComponent } from 'react';

import { ImageresizeApi } from 'modules';
import { BannerAd, BulkList, Button, ImagePicker } from 'components';
import { GENERIC_UPLOAD_ERROR, MAX_UPLOAD_COUNT } from 'constants/images';
import { getId, getUploadedImageErrorMessage, throttle } from 'utils';
import intl from 'react-intl-universal';

function getPageSize(page) {
  const [x, y, w, h] = page.pageInfo.view;
  const width = Math.round((w - x));
  const height = Math.round((h - y));
  const rotate = page.pageInfo.rotate;
  // Consider rotation
  return (rotate === 90 || rotate === 270)
    ? { width: height, height: width, rotate } : { width, height, rotate };
  // return (rotate === 90 || rotate === 270)
  //     ? height + 'x' + width  : width + 'x' + height + ' mm';
}

function setPdfSize($this, id, file, url) {
  if (url) {
    fetch('/api/v2/url/' + encodeURIComponent(url))
      .then(res => res.text())
      .then(size => {
        let sizes = $this.state.sizes;

        sizes[id] = JSON.parse(size);
        $this.setState({ sizes: sizes, sizeCount: $this.state.sizeCount + 1 })
        console.log(size);
      });
  } else {
    const fileReader = new FileReader();
    fileReader.onload = function (ev) {

      window.pdfjsLib.getDocument(fileReader.result).then((pdf) => {

        pdf.getPage(1).then((page) => {
          let sizes = $this.state.sizes;

          sizes[id] = getPageSize(page);
          console.log(sizes);
          $this.setState({ sizes: sizes, sizeCount: $this.state.sizeCount + 1 });
        });
      });
    }

    fileReader.readAsArrayBuffer(file);
  }
}

export default class PdfSelect extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      bulkImages: [],
      urlValues: {},
      sizes: {},
      maxLimitReached: false,
      sizeCount: 0
    };
  }

  componentDidMount() {
    const script = document.createElement("script");

    script.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.0.550/pdf.js";
    script.async = true;

    document.body.appendChild(script);
  }

  handleDropImages = (acceptedFiles, rejectedFiles) => {
    const { onErrors } = this.props;
    const { urlValues } = this.state;

    const urlCount = Object.values(urlValues).filter((val) => !!val).length;

    let currentFiles = this.state.bulkImages.length + urlCount;
    if (currentFiles >= MAX_UPLOAD_COUNT) {
      return;
    }
    // The upload failed, tell our parent
    if (rejectedFiles.length) {
      return onErrors(rejectedFiles.map(getUploadedImageErrorMessage));
    }
    let limitReached = this.state.maxLimitReached;
    if (acceptedFiles.length > MAX_UPLOAD_COUNT - currentFiles) {
      limitReached = true;
      acceptedFiles = acceptedFiles.slice(0, MAX_UPLOAD_COUNT - currentFiles);
    }
    // Format the files in a way that's useful for the rest of the app and API
    const images = acceptedFiles.map((file) => ({
      id: getId(),
      contentLength: file.size,
      name: file.name,
      state: 'ready',
      uploadType: 'pdf',
      uploadProgress: -1,
      value: file
    }));

    // Store the successful uploads
    this.setState(({ bulkImages }) => ({
      maxLimitReached: limitReached,
      bulkImages: [...bulkImages, ...images]
    }));
  };

  handleChangeUrl = (name, value) => this.setState(({ urlValues }) => ({
    urlValues: {
      ...urlValues,
      [name]: value
    }
  }));

  handleRemoveImage = (id) => this.setState(({ bulkImages }) => ({
    bulkImages: bulkImages.filter((image) => image.id !== id)
  }));

  handleProceedToBulkResize = () => {
    const { urlValues } = this.state;
    const { onDone, onErrors } = this.props;
    const urls = Object.values(urlValues).map((value) => ({
      id: getId(),
      name: value,
      state: 'ready',
      uploadType: 'url',
      uploadProgress: -1,
      value
    }));
    const bulkImages = [...this.state.bulkImages, ...urls];
    let inFlightUploads = 0;

    // Set up the final list including urls and uploaded images, also cleanup urls
    this.setState({
      urlValues: {},
      bulkImages
    });

    // When an upload is successful, call onDone as soon as we can
    const uploadSuccessful = () => {
      console.log('done', this.state.sizeCount, this.state.bulkImages.length);
      inFlightUploads -= 1;

      if (inFlightUploads < 1) {
        if (this.state.sizeCount === this.state.bulkImages.length) {
          const images = this.state.bulkImages.map((image) => ({
            ...image,
            // actualSize: this.state.sizes[image.id].width + 'x' + this.state.sizes[image.id].height + ' mm',
            oldSizes: this.state.sizes[image.id]
          }));
          onDone(images);
        } else {
          console.log('calling again');
          setTimeout(uploadSuccessful, 200);
        }
      }
    };

    // As each upload finishes, update the app state. Once all uploads are complete, tell our parents.
    const uploadDone = (err, data) => {

      if (err) {
        return onErrors([err]);
      }

      const { image, result } = data;

      // The image has already been uploaded
      if (image.imageId) {
        return uploadSuccessful();
      }

      this.setState(
        ({ bulkImages }) => {
          const newImage = {
            ...image,
            state: 'uploaded',
            uploadProgress: 1,
            contentLength: result.contentLength,
            dimensions: result.dimensions,
            imageId: result.imageId,
            // preview: ImageresizeApi.getImageUrl(result.imageId),
            type: 'pdf',
            name: image.uploadType === 'pdf' ?
              image.value.name :
              image.value
          };

          return {
            bulkImages: bulkImages.map((item) => (item.id === newImage.id) ? newImage : item)
          };
        },
        () => {
          uploadSuccessful();
        }
      );
    };

    // Update the progress of each image that's being uploaded, batch state updates so the UI doesn't get overloaded
    const updateProgress = ((self) => {
      const status = {};
      const updateState = throttle(() => self.setState(({ bulkImages }) => ({
        bulkImages: bulkImages.map((item) => {

          // Only update progress if this value is larger to avoid race conditions
          if (status[item.id] && status[item.id] > item.uploadProgress) {
            return {
              ...item,
              state: 'uploading',
              uploadProgress: status[item.id]
            };
          }

          return item;
        })
      })), 50);

      return (imageId, percentComplete) => {
        status[imageId] = percentComplete;

        updateState();
      };
    })(this);

    // Trigger the upload
    bulkImages.forEach((image) => {
      if (image.uploadType === 'url') {
        setPdfSize(this, image.id, null, image.value);
      } else {
        setPdfSize(this, image.id, image.value, false);
      }
      inFlightUploads += 1;

      // If the image is somehow already uploaded, don't reupload it.
      if (image.imageId) {
        return uploadDone(null, { image });
      }

      const upload = ImageresizeApi.postImages([image]);

      upload.on('error', (ev) => uploadDone(new Error(GENERIC_UPLOAD_ERROR)));
      upload.on('progress', ({ percentComplete }) => updateProgress(image.id, percentComplete));
      upload.on('load', () => {

        if (
          upload.xhr.status !== 200 ||
          !upload.response.results ||
          !upload.response.results.length ||
          upload.response.results.find((result) => result.state === 'error')
        ) {
          return uploadDone(new Error(GENERIC_UPLOAD_ERROR));
        }

        const result = upload.response.results[0];

        uploadDone(null, { result, image });
      });
    });
  }

  isUploadInProgress = () => {
    const { bulkImages } = this.state;

    return !!bulkImages.find((image) => image.state !== 'ready');
  };

  shouldPickerBeDisabled() {
    const { bulkImages, urlValues } = this.state;
    const urlCount = Object.values(urlValues).filter((val) => !!val).length;

    return !!(this.isUploadInProgress() || (urlCount + bulkImages.length) >= MAX_UPLOAD_COUNT);
  }

  shouldButtonBeActive() {
    const { bulkImages, urlValues } = this.state;
    const urlsPopulated = Object.values(urlValues).find((val) => !!val);
    const uploadsInProgress = bulkImages.find((val) => Math.abs(val.uploadProgress) !== 1);

    return !!((bulkImages.length || urlsPopulated) && !uploadsInProgress);
  }

  renderList() {
    const { bulkImages } = this.state;

    if (!bulkImages.length) {
      return null;
    }

    return (
      <BulkList
        images={bulkImages}
        removeImage={this.handleRemoveImage}
      />
    );
  }

  renderButton() {
    return (
      <div className="selection-box">
        <Button
          className='main-button'
          disabled={!this.shouldButtonBeActive()}
          onClick={this.handleProceedToBulkResize}
        >
          {intl.get('Proceed to PDF Resize')}
        </Button>
      </div>
    );
  }

  clearLimitReachMsg = () => this.setState({ maxLimitReached: false });

  render() {
    const { maxLimitReached } = this.state;
    return (
      <div className='container'>
        <div className="center section">
        <h1>{intl.get('PdfResize.PageHeader')}</h1>
        <p>{intl.get('PdfResize.PageHeaderDescription')}</p>
        </div>
        <div className='selection-box'>
          <ImagePicker
            accept=".pdf"
            fileType="PDF"
            buttonText="Choose PDF files to Resize"
            disabled={this.shouldPickerBeDisabled()}
            uploading={this.isUploadInProgress()}
            dropImages={this.handleDropImages}
            changeUrl={this.handleChangeUrl}
            submitUrlUpload={this.handleProceedToBulkResize}
            multiple={true}
            maxLimitReached={maxLimitReached}
            clearLimitReachMsg={this.clearLimitReachMsg}
          />
        </div>
        {this.renderList()}
        {this.renderButton()}
        <BannerAd />
        <div className='content'>
          {/* <ReactMarkdown className='section' source={howToResizePdf} />
          <ReactMarkdown className='section' source={resizePdfOnline} /> */}
          <div className="section">
            <h2>{intl.get('PdfResize.HowToResize')}</h2>
            <ol>
              <li>{intl.get('PdfResize.Ans1')}</li>
              <li>{intl.get('PdfResize.Ans2')}</li>
              <li>{intl.get('PdfResize.Ans3')}</li>
              <li>{intl.get('PdfResize.Ans4')}</li>
              <li>{intl.get('PdfResize.Ans5')}</li>
              <li>{intl.get('PdfResize.Ans6')}</li>
              <li>{intl.get('PdfResize.Ans7')}</li>
            </ol>
          </div>

          <div className="section">
            <h2>{intl.get('PdfResize.ResizePDFOnline')}</h2>
            <p>{intl.get('PdfResize.ResizePDFOnlinePara')}</p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/PdfResize/PdfSelect.jsx